import React, { useEffect } from "react";
import { observer } from "mobx-react-lite";
import { FormProvider, useForm } from "react-hook-form";
import { Typography, FormControl } from "@mui/material";
import { FormButtons, TailwindModal } from "../../components";
import { useStore } from "../../helpers";

import OfficePersonAutoComplete from "../../new-features/service-requests/sr-settings/assignees/office-person-auto-complete";
import { useAssignee } from "../../new-features/service-requests/sr-settings/assignees/hooks";
import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";

export const AddManager = observer(() => {
  const { userStore } = useStore();
  const { activeUser, selectedManager } = userStore;
  const { projectid } = useParams<{ projectid: string }>();
  const numericProjectId = parseInt(projectid || "0");
  const numericUserId = parseInt(activeUser?.id || 0);

  const defaultValues = {
    manager: "",
  };

  const methods = useForm({
    defaultValues,
  });

  console.log(activeUser);

  const resetModal = () => {
    methods.reset(defaultValues);
  };

  useEffect(() => {
    if (selectedManager) {
      methods.reset({
        manager: selectedManager,
      });
    } else {
      methods.reset(defaultValues);
    }
  }, [selectedManager]);

  const { mutate, isLoading } = useMutation({
    mutationFn: async (data) => {
      return await userStore.add_manager_user(data);
    },
    onSuccess: async (response: any) => {
      console.log("MUTATION RESPONSE:", response);

      await userStore.get_user_permissions_and_parts({
        userid: numericUserId,
        projectid: numericProjectId,
      });
      toast.success("Manager added successfully!");
      userStore.setAddManager(false);
    },
  });

  const onSubmit = (data: any) => {
    const payload = {
      projectid: parseInt(projectid),
      mgrid: data?.manager?.id,
      reportee: activeUser?.id,
    };

    // @ts-ignore
    mutate(payload);
    resetModal();
    userStore.setAddManager(false);
  };

  const { data: officeUserData = [] } = useAssignee();

  return (
    <TailwindModal isOpen={userStore.add_manager}>
      <div className="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle max-w-lg w-full">
        <FormProvider {...methods}>
          <form
            onSubmit={methods.handleSubmit(onSubmit)}
            className="bg-white px-4 py-4 rounded-sm flex flex-col gap-y-4"
          >
            <Typography variant="h5" color="primary">
              Add Manager
            </Typography>

            <FormControl fullWidth>
              <OfficePersonAutoComplete
                name="manager"
                label={"Manager"}
                officeUserData={officeUserData}
              />
            </FormControl>

            <FormButtons
              onSave={() => {}}
              onCancel={() => userStore.setAddManager(false)}
              type="submit"
            />
          </form>
        </FormProvider>
      </div>
    </TailwindModal>
  );
});
